import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { compose, branch, renderNothing } from 'recompose';

import {
  Panel,
  Grid,
} from 'react-bootstrap';

import PerDiemReportTable from '../components/PerDiemReportTable';

import { queryGetAllDistrictUserDailyTimeEntryGroupsDataGQL } from '../graphql/AllDistrictUserDailyTimeEntryGroupsApi';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  districtId: PropTypes.number.isRequired,
  departmentId: PropTypes.number,

  allDistrictUserDailyTimeEntryGroups: PropTypes.array.isRequired,
  interval: PropTypes.array.isRequired,
  data: PropTypes.object,
});
/* eslint-enabled react/no-unused-prop-types */

const PerDiemReportView = (props) => {
  const { allDistrictUserDailyTimeEntryGroups, interval } = props;
  return (
    <Grid fluid>
      <Panel header="7 day Per Diem Status" />
      <PerDiemReportTable
        allDistrictUserDailyTimeEntryGroups={allDistrictUserDailyTimeEntryGroups}
        interval={interval}
      />
    </Grid>
  );
};


PerDiemReportView.propTypes = propTypes;


const withHide = branch(
  (props) => {
    return !props.startDate || !props.endDate || !props.districtId;
  },
  renderNothing,
);

const enhance = compose(
  withHide,
  queryGetAllDistrictUserDailyTimeEntryGroupsDataGQL,
);


export default enhance(PerDiemReportView);
